export default {
  "common-try-slogin": "连接全球人与应用",
  "common-button-立即试用": "立即试用",
  "common-consult": "方案咨询",
  "common-consult-descript": "获取更多信息，请联系我们的销售和技术支持团队。",
  "common-customer": "了解 Authing，帮助你实现快速增长",
  "common-more": "了解更多",
  "input-placeholder": "输入手机号立即开始",
  "try-on": "免费使用",
  "check-fun": "查看功能",
  nav: {
    "nav-home": "首页",
    "nav-product": "产品与服务",
    "nav-solution": "解决方案",
    "nav-resource": "资源中心",
    "nav-case": "成功案例",
    "nav-cloud-native": "云原生",
    "nav-solution-medical": "医疗",
    "nav-solution-government": "政府",
    "nav-solution-education": "教育",
    "nav-solution-finance": "金融",
    "nav-solution-energy": "能源",
    "nav-solution-enterprise": "企业",
    "nav-solution-game": "游戏",
    "nav-solution-software": "科技",
    "nav-solution-publisher": "出版",
    "nav-solution-wechat": "全场景微信登录解决方案",
    "nav-solution-idaas": "全面替代 IAM",
    "nav-solution-okta": "全面替代 Okta",
    "nav-solution-ad": "全面替代 AD",
    "nav-solution-cognito": "全面替代 AWS Cognito",
    "nav-solution-keycloak": "Keycloak VS Authing",
    "nav-solution-private-cloud": "私有部署身份云",
    "nav-solution-mfa": "自适应 MFA",
    "nav-solution-build-idaas": "构建企业专属的身份云",
    "nav-solution-identity": "不同身份源的用户信息同步及更新",
    "nav-solution-zero-trust": "为组织构建零信任网络",
    "nav-solution-digital-identity": "为公民建设数字身份",
    "nav-developer": "开发者",
    "nav-developer-center": "开发者中心",
    "nav-developer-center-descript": "在这里找到和 Authing 开发相关的内容",
    "nav-developer-community": "开发者论坛",
    "nav-developer-community-descript": "与 Authing 的工程师和用户在线交流",
    "nav-developer-document": "开发者文档",
    "nav-developer-document-descript": "帮助你快速上手 Authing",
    "nav-developer-blog": "博客",
    "nav-price": "价格",
    "nav-abuoutus": "关于 Authing",
    "nav-company-intro": "公司介绍",
    "nav-customer": "客户故事",
    "nav-customer-success": "客户成功服务",
    "nav-marketplace": "合作网络",
    "nav-console": "控制台",
    "nav-personal": "个人中心",
    "nav-login": "登录/注册",
    "nav-mobile-login": "立即登录",
    "nav-logout": "退出",
    "nav-type-customer": "客户故事",
    "nav-customer-hep": "高等教育出版社",
    "nav-customer-cnpn": "中国石油",
    "nav-customer-futu": "富途牛牛",
    "nav-customer-southeast-university": "东南大学",
    "nav-customer-xian-gong": "仙工智能",
    "nav-case-description":
      "互联网创业公司、独角兽和世界 500 强企业都在使用 Authing 授权、集成和管理他们的员工和用户。",
    "nav-resource-whitepaper": "白皮书",
    "nav-resource-whitepaper-descript": "感受集成 Authing 的便利性",
    "nav-resource-demo": "体验 Demo",
    "nav-resource-demo-descript": "感受 Authing 控制台的高效交互性",
    "nav-type-application": "我们的优势",
    "nav-type-company": "公司介绍",
    "nav-type-about": "关于我们",
    "nav-type-news": "快讯连接",
    "nav-type-APN": "合作网络",
    "nav-type-APN-img":
      "//files.authing.co/authing-website/nav-about-img-new.png",
    "nav-about-financing": "融资信息",
    "nav-about-news": "重大新闻",
    "nav-type-product": "我们的产品",
    "nav-type-service": "安全与服务",
    "nav-product-extra-title": "产品优势",
    "nav-type-industry": "行业领域",
    "nav-type-staff": "员工身份",
    "nav-type-user": "用户身份",
    "nav-type-extend": "扩展功能",
    "nav-extend-database": "连接自定义数据库",
    "nav-extend-pipeline": "身份工作流 Pipeline",
    "nav-extend-operate": "IDaaS 运营平台",
    "nav-extend-maintenance": "IDaaS 运维平台",
    "nav-extend-radius": "网络认证（Radius）",
    "nav-type-scense": "场景解决方案",
    "nav-solution-extra-title": "微信生态解决方案",
    "nav-solution-extra-subtitle":
      "Authing 作为优秀的身份管理解决方案提供商，无论在 B2B，B2C，B2E 或 IoT 场景，都会为企业带来显著的竞争优势：降低开发成本、提高安全性、助力生产效率。",
    "nav-type-developer": "相关资源介绍",
    "nav-developer-doclink": "常用文档跳转",
    "nav-developer-extra-oidc": "使用 OIDC",
    "nav-developer-extra-mfa": "移动安全 MFA",
    "nav-about-extra-title": "了解 Authing",
    "nav-developer-extra-start": "快速开始",
    "nav-developer-extra-start-subtitle": "为你的应用轻松集成身份系统",
    "nav-developer-extra-pipeline": "自定义认证流程",
    "nav-developer-extra-pipeline-subtitle": "根据你的需求灵活配置认证流程",
    "nav-developer-extra-pipeline-img-default":
      "//files.authing.co/authing-website/nav-developer-pipeline-new.png",
    "nav-developer-extra-pipeline-img":
      "//files.authing.co/authing-website/nav-developer-pipeline-default.png",
    "nav-developer-extra-start-img-default":
      "//files.authing.co/authing-website/nav-developer-getstart-default.png",
    "nav-developer-extra-start-img":
      "//files.authing.co/authing-website/nav-developer-getstart-new.png",
    "nav-developer-blog-descript": "在 Authing 博客上关注最新动态",
    "nav-tag-joinus": "正在招募",
    "learn-more": "查看更多",
    "nav-overview": "总览",
    "news-blog1": "Authing Share｜密码：安全领域的基石",
    "news-blog2": "继 Facebook 后领英再爆 5 亿数据泄露，用户关键信息统统流出",
    "news-blog3": "Theragun 如何用 Authing 为百万用户统一登录体验",
  },
  footer: {
    "footer-product": "产品介绍",
    "footer-product-advance": "产品优势",
    "footer-platform": "开放平台",
    "footer-support-doc": "开发者文档",
    "footer-platform-api": "Open API",
    "footer-platform-resource": "开发资源",
    "footer-platform-problem": "常见问题",
    "footer-platform-example": "集成案例",
    "footer-solution": "解决方案",
    "footer-support": "技术支持",
    "footer-doc": "开发者文档",
    "footer-support-community": "开发者论坛",
    "footer-support-Github": "Github",
    "footer-support-blog": "技术博客",
    "footer-company": "公司信息",
    "footer-company-joinus": "加入我们",
    "footer-company-phone": "400-6197-031",
    "footer-company-email": "sales@authing.cn",
    "company-address-name": "北京地址（总）",
    "branch-address-name": "成都地址（分）",
    "beijing-company-address": "北京市海淀区中关村东路威盛大厦 6 层",
    "chengdu-company-address":
      "成都市高新区天府五街 200 号 1 号楼 B 区 4 楼 406 室",
    "mobile-total-company-address": "北京市海淀区中关村东路威盛大厦 6 层（总）",
    "mobile-branch-company-address":
      "成都市高新区天府五街 200 号 1 号楼 B 区 4 楼 406 室（分）",
    "footer-language": "语言 - Language",
    "footer-adress": "京ICP备19051205号-7",
    "footer-copyright": "© 北京蒸汽记忆科技有限公司",
    "footer-sitemap": "网站地图",
    "footer-okta": "OKTA",
    "footer-solution-wechat": "微信登录解决方案",
    "footer-solution-cognito": "全面替代 Cognito",
  },
  common: {
    "product-sso": "单点登录",
    "product-mfa": "自适应多因素认证",
    "product-comp": "通用登录组件",
    "product-verify": "手机号码闪验",
    "product-security": "安全与合规",
    "product-database": "自定义数据库连接",
    "product-authorization": "授权",
    "product-api": "API 访问管理（M2M）",
    "product-user-management": "用户管理",
    "product-user-directory": "用户目录",
    "product-life-cycle": "生命周期管理",
    "product-gateway": "应用集成网关",
    "product-gateway-integration": "应用集成网关",
  },
  button: {
    "try-now": "立即使用",
    "buy-now": "立即购买",
    "see-more": "查看更多",
    "learn-more": "查看详情",
    "develop-consult": "开发咨询",
    "develop-community": "开发文档",
    "contact-us": "联系我们",
    "quick-start": "快速开始",
    "wait-consult": "等待联系",
    consult: "预约咨询",
    linkDoc: "查看文档",
  },
  form: {
    name: "姓名",
    phone: "电话",
    company: "公司",
    other: "备注",
    submit: "立即提交",
    cancel: "取消",
    // "contact-form-title": "注册你的信息，我们会在 15 分钟内安排专家联系你",
    "contact-form-title": "获得企业级解决方案",
    "contact-subtitle":
      "Authing 已向超过 28 个行业输出了实践方案，我们很乐意与你所在的企业分享经验，并提供免费演示方案。",
    "success-tip": "你已经提交成功！",
    "success-wait-tip": "专家正在赶来的路上...",
    "success-try-tip": "在等待期间，你是否想免费使用？",
    "name-placeholder": "希望我们怎么称呼你？",
    "phone-placeholder": "我们的顾问将尽快致电你",
    "company-placeholder": "请填写你的公司信息",
    position: "职位",
    "position-placeholder": "请填写你的职位信息",
    "contact-name": "名字",
    "contact-way": "手机",
    "contact-title": "获得企业级解决方案",
    "contact-tip": "你也可以通过微信或手机和我们的销售人员直接联系",
    "apply-title": "提交你的申请",
    "apply-name": "真实姓名",
    "apply-email": "电子邮箱",
    "apply-type": "投递类型",
    "apply-position": "投递岗位",
    "apply-method": "简历投递方式",
    "mail-address": "邮箱地址",
    "mail-title": "邮件标题：姓名 + 岗位名称",
    "mail-content": "投递内容：邮件内容 + 附件简历",
    otherTip: "你是否想与客服代表联系？",
    otherTip1: "请致电",
    otherTip2: "联系我们",
  },
  // notice: "Authing 新版本已于 2020-09-17 发布，性能突飞猛进。咨询电话：176-0250-2507",
  notice:
    "Authing 正在参加 HW 行动，时间为 10 个工作日，你可以正常使用 Authing 产品，你的员工和已上线的业务都不受任何影响。请转向 www.authing.co 继续访问官网。咨询电话：19816542466 或 17602502507",
  linkDoc: "查看文档",
  about: {
    title: "关于 Authing",
    description1:
      "Authing 是国内首款以开发者为中心的全场景身份云产品，集成了所有主流身份认证协议，为企业和开发者提供完善安全的用户认证和访问管理服务。",
    description2:
      "Authing 被科技部认定为「2020 国家高新技术企业」，被中国信息通信研究院评选为「国内身份管理与访问控制领域创新企业」，并被录入《2019 网络安全产业白皮书》。Authing 已为中国石油、国家电网、招商银行、日本丰田、德高集团等国内外优秀企业打造了卓越的开发方式、高效的办公流程和安全的 IT 管理体系。",
    qrcodePublic: "「Authing 身份云」公众号",
    qrcodeBusiness: "商务合作",
  },
  logo: {
    中国石油: "中国石油",
    国家电网: "国家电网",
    丰田: "丰田",
    招商银行: "招商银行",
    高等教育出版社: "高等教育出版社",
    东南大学: "东南大学",
    华西医院: "华西医院",
    德高集团: "德高集团",
    云测: "云测",
    盼达用车: "盼达用车",
    THERAGUN: "THERAGUN",
    宾利: "宾利",
    stackchat: "Stackchat",
    chatopera: "Chatopera",
    腾讯云: "腾讯云",
    亚马逊: "亚马逊",
    乐智机器人: "乐智机器人",
    文因互联: "文因互联",
    金蝶: "金蝶",
    freeCodeCamp: "freeCodeCamp",
    阿里云: "阿里云",
    句子互动: "句子互动",
    华为云: "华为云",
    金证优智: "金证优智",
    一清创新: "一清创新",
  },

  pageLink: {
    title: "你可能还想了解",
    sso: {
      title: "单点登录",
      description:
        "单点登录（SSO）是整合企业系统的解决方案之一，旨在多个应用系统中，用户只需要登录一次就可以访...",
    },
    mfa: {
      title: "自适应多因素认证",
      description:
        "多因素认证（MFA）是一种简单有效的最佳安全实践方法，它能够在用户名和密码之外再额外增加一层安...",
    },
    comp: {
      title: "通用登录组件",
      description:
        "登录组件（Guard) 帮助开发者屏蔽了很多底层认证的实现细节，同时也包括繁琐的 UI 开发...",
    },
    verify: {
      title: "手机号码闪验",
      description:
        "依托于微信官网的实名用户信息，用户一键授权即可以真实号码完成注册/登录，为开发者建立以手机...",
    },
    database: {
      title: "自定义数据库连接",
      description:
        "当你想保障数据安全性或平滑迁移用户时，请使用 Authing 自定义数据库连接，既能连接自己维护的...",
    },
    iam: {
      title: "全面替代 IAM",
      description:
        "随着企业数字转型和上云进度的加速，企业信息安全的维度和边界正在变得越来越复杂，身份认证和访问...",
    },
    okta: {
      title: "全面替代 Okta",
      description:
        "我们通过身份中台、工作流、目录、应用集成、用户分析、开发组件六个维度与 Okta 进行对比可...",
    },
    wechat: {
      title: "微信生态解决方案",
      description:
        "Authing 快速实现任何 Web、App 和企业软件的身份认证和用户管理，为你的顾客和员工提供最完善的登录...",
    },
    keycloak: {
      title: "Keycloak VS Authing",
      description:
        "Keycloak 是一个开源软件产品，旨在为现代的应用程序和服务，提供包含身份管理和访问管理功能的...",
    },
    buildIdaas: {
      title: "构建企业专属的身份云",
      description:
        "随着企业逐渐加快数字化转型，「身份和访问管理」对于企业成功至关重要。完善的身份和访问管理解决...",
    },
  },
};
